export default __webpack_public_path__ + "static/media/icons8-price-tag-96.4a35f036.svg";